var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconMusic = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 14,
    viewBox: "0 0 10 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.86879 8.81357C9.28319 8.12018 9.55808 7.24318 9.61142 6.3754C9.64527 5.81843 9.52116 5.23376 9.25241 4.68397C8.83084 3.8203 8.10667 3.33513 7.40712 2.86637C6.88503 2.51659 6.39165 2.18631 6.0429 1.71447L5.98033 1.63036C5.77416 1.35341 5.54132 1.03954 5.50439 0.775922C5.46746 0.509232 5.22539 0.319471 4.96075 0.334857C4.69201 0.35332 4.48379 0.575904 4.48379 0.845672V9.98496C4.05401 9.72443 3.52473 9.56441 2.94519 9.56441C1.53173 9.56441 0.380859 10.4845 0.380859 11.6159C0.380859 12.7473 1.53173 13.6673 2.94519 13.6673C4.35865 13.6673 5.50952 12.7473 5.50952 11.6159V5.6379C6.27984 5.93229 7.54047 6.6821 7.88717 8.43303C7.82254 8.52842 7.761 8.63099 7.6892 8.71305C7.50149 8.92538 7.522 9.24951 7.73536 9.4362C7.94666 9.62493 8.27079 9.60236 8.4585 9.39004C8.59595 9.23413 8.71801 9.05154 8.83494 8.86076C8.84725 8.8464 8.85857 8.83101 8.86879 8.81357Z",
    fill: "#E5E4EC"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconMusic);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-music.2efecea573efc6e87cedbd1b6a99dfa5.svg";